export default __webpack_public_path__ + "static/dharmendra-b853c5976ec76c93c87f44ac2d8fa679.png";